import React from 'react'
import styled from 'styled-components'
import { UnsupportedChainIdError } from '@web3-react/core'
import { Borders, Colors, FontWeights } from '../../constants'
import { Account } from './Account'
import { Wallet as WalletIcon } from '../icons'
import { ConnectModal } from './ConnectModal'
import { WalletModal } from './WalletModal'
import { Spinner } from '../../common'
import { useConnection } from './useConnection'

interface Props {
  className?: string
}

export function Connection({ className }: Props) {
  const {
    account,
    active,
    change,
    connect,
    disconnect,
    error,
    isConnectModalOpen,
    isWalletModalOpen,
    setConnectModalClose,
    setWalletModalOpen,
    toggleConnectModal,
  } = useConnection()

  let prompt
  if (error instanceof UnsupportedChainIdError) {
    prompt = (
      <NetworkError className={className} onClick={() => setWalletModalOpen(true)}>
        Unsupported network
      </NetworkError>
    )
  } else if (!active) {
    prompt = (
      <Loader className={className}>
        <Spinner />
      </Loader>
    )
  } else if (account) {
    prompt = <Account className={className} address={account} onClick={() => setWalletModalOpen(true)} />
  } else {
    prompt = (
      <Connect className={className} onClick={toggleConnectModal}>
        <WalletStyled />
        Connect Wallet
      </Connect>
    )
  }

  return (
    <>
      {prompt}
      {isWalletModalOpen && (
        <WalletModal disconnect={disconnect} change={change} onClose={() => setWalletModalOpen(false)} />
      )}
      {isConnectModalOpen && <ConnectModal connect={connect} onClose={setConnectModalClose} />}
    </>
  )
}

const NetworkError = styled.div`
  padding: 8px 12px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  height: 42px;
  color: ${Colors.White};
  font-size: 13px;
  font-weight: ${FontWeights.Bold};
  text-transform: uppercase;
  white-space: nowrap;
  background-color: ${Colors.Red};
  border-radius: ${Borders.Radius};
`

const Connect = styled.button`
  padding: 8px 12px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  height: 42px;
  color: ${Colors.White};
  font-size: 13px;
  font-weight: ${FontWeights.Bold};
  text-transform: uppercase;
  white-space: nowrap;
  cursor: pointer;
  outline: none;
  background-color: #00000020;
  border: 0;
  border-radius: ${Borders.Radius};
  &:hover {
    background-color: ${Colors.Hover};
  }
  @media (max-width: 1024px) {
    background-color: #435069;
  }
`

const WalletStyled = styled(WalletIcon)`
  margin-right: 8px;
  width: 23px;
  height: 18px;
`

const Loader = styled.div`
  padding: 8px 12px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  height: 42px;
  color: ${Colors.White};
  background-color: #00000020;
  @media (max-width: 1024px) {
    background-color: #435069;
  }
`
